import React from "react";
import { useMsal } from "@azure/msal-react";
import Button from "react-bootstrap/Button";
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";

const handleLogout = instance => {
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("azureToken");
  instance.logoutRedirect().catch(e => {
    console.error(e);
  });
};

// const logoutTooltip = props => (
//   <Tooltip id="button-tooltip" {...props}>
//     Redirects to Microsoft Azure
//   </Tooltip>
// );

// export const SignOutButton = () => {
//   const { instance } = useMsal();

//   return (
//     <OverlayTrigger
//       placement="bottom"
//       delay={{ show: 100, hide: 400 }}
//       overlay={logoutTooltip}
//     >
//       <Button
//         variant="warning"
//         className="ml-auto"
//         onClick={() => handleLogout(instance)}
//       >
//         Sign Out
//       </Button>
//     </OverlayTrigger>
//   );
// };

export const SignOutButton = () => {
  const { instance } = useMsal();

  return (
    <Button
      variant="warning"
      className="ml-auto"
      onClick={() => handleLogout(instance)}
    >
      Sign Out
    </Button>
  );
};
